var map = {
	"./acc_1.jpg": 87,
	"./acc_2.jpg": 9961,
	"./alva_1.jpg": 391,
	"./alva_2.jpg": 2963,
	"./alva_3.jpg": 2523,
	"./alva_4.jpg": 6218,
	"./alva_5.jpg": 4655,
	"./cabras.jpg": 8255,
	"./ex_1.jpg": 4965,
	"./ex_2.jpg": 1981,
	"./ex_3.jpg": 1369,
	"./fauna.jpg": 4869,
	"./hero_image_1.jpg": 7231,
	"./hero_image_2.jpg": 88,
	"./lagoas.jpg": 7949,
	"./mondego_1.jpg": 5025,
	"./mondego_2.jpg": 6718,
	"./mondego_3.jpg": 7422,
	"./mondego_4.jpg": 2051,
	"./mondego_5.jpg": 5167,
	"./primeiracasinha_1.jpg": 6210,
	"./primeiracasinha_2.jpg": 9347,
	"./primeiracasinha_3.jpg": 2522,
	"./primeiracasinha_4.jpg": 1070,
	"./primeiracasinha_5.jpg": 3391,
	"./region.png": 512,
	"./region_1.jpg": 1132,
	"./region_11.jpg": 1100,
	"./region_2.jpg": 5424,
	"./region_22.jpg": 5378,
	"./region_3.jpg": 516,
	"./region_33.jpg": 4153,
	"./region_4.jpg": 7014,
	"./region_44.jpg": 1638,
	"./region_55.jpg": 5637,
	"./serra.jpg": 6974,
	"./sotao_1.jpg": 6515,
	"./sotao_2.jpg": 8461,
	"./sotao_3.jpg": 9832,
	"./sotao_4.jpg": 3202,
	"./sotao_5.jpg": 8085,
	"./zezere_1.jpg": 6383,
	"./zezere_2.jpg": 9762,
	"./zezere_3.jpg": 8584,
	"./zezere_4.jpg": 7817,
	"./zezere_5.jpg": 8290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;